const styles = theme => ({
  textColor: {
    color: 'rgba(52, 118, 203, 1.0)',
  },
  root: {
    marginLeft: 0,
    paddingLeft: 24,
    paddingRight: 24,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 28,
      paddingRight: 28,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 28,
      paddingRight: 28,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/Age/styles.js